export default __webpack_public_path__ + "static/media/Fiche_Organisé.dd3bad16.svg";